import Vue from "vue";
import CompanyLocationMap from "../components/map/CompanyLocationMap.vue";

export default () => {
  const elements = document.querySelectorAll(".vue-company-location-map");

  if (elements) {
    elements.forEach((el) => {
      let entry = CompanyLocationMap;

      new Vue({
        el,

        computed: {
          mapZoom() {
            let zoom = 10;
            if (el.dataset.zoom) {
              zoom = el.dataset.zoom;
            }

            return zoom;
          },

          mapCenter() {
            let center = {
              lat: this.$yeti.company().lat,
              lng: this.$yeti.company().lng
            };
            if (el.dataset.center) {
              center = JSON.parse(el.dataset.center);
            }

            return center;
          },

          mapMarkers() {
            if (el.dataset.mapmarkers) {
              return JSON.parse(el.dataset.mapmarkers);
            }

            return [];
          }
        },

        render: h => h(entry)
      })
    });
  }
};
